
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/faq",
      function () {
        return require("private-next-pages/info/faq.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/faq"])
      });
    }
  